import TokenInput from './TokenInput';
import {
  JS__TOKEN__DELETE_BUTTON__CLASS_NAME,
  KEY_DOWN_HANDLER_CONFIG_OPTION,
} from './constants';

export {
  // The className to build customize token delete button
  JS__TOKEN__DELETE_BUTTON__CLASS_NAME,
  // Constant to help config the special keyDown event handler setting
  KEY_DOWN_HANDLER_CONFIG_OPTION,
};

export default TokenInput;
